import React from 'react'
import {Icon} from '@chakra-ui/react'

const FiltersIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.5602 8.91568H1.91996C1.38977 8.91568 0.959961 9.34549 0.959961 9.87568C0.959961 10.4059 1.38977 10.8357 1.91996 10.8357H35.6528C36.2184 13.423 38.523 15.36 41.28 15.36C44.4611 15.36 47.04 12.7811 47.04 9.59997C47.04 6.41881 44.4611 3.83997 41.28 3.83997C38.3303 3.83997 35.8985 6.05707 35.5602 8.91568ZM41.28 13.44C43.4007 13.44 45.12 11.7207 45.12 9.59997C45.12 7.47919 43.4007 5.75997 41.28 5.75997C39.1592 5.75997 37.44 7.47919 37.44 9.59997C37.44 11.7207 39.1592 13.44 41.28 13.44Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.71996 29.76C3.5388 29.76 0.959961 27.1811 0.959961 24C0.959961 20.8188 3.5388 18.24 6.71996 18.24C9.57404 18.24 11.9433 20.3158 12.4003 23.04H46.08C46.6102 23.04 47.04 23.4698 47.04 24C47.04 24.5302 46.6102 24.96 46.08 24.96H12.4003C11.9433 27.6842 9.57404 29.76 6.71996 29.76ZM6.71996 27.84C8.84073 27.84 10.56 26.1207 10.56 24C10.56 21.8792 8.84073 20.16 6.71996 20.16C4.59919 20.16 2.87996 21.8792 2.87996 24C2.87996 26.1207 4.59919 27.84 6.71996 27.84Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M35.5996 39.36C36.0566 42.0842 38.4259 44.16 41.28 44.16C44.4611 44.16 47.04 41.5811 47.04 38.4C47.04 35.2188 44.4611 32.64 41.28 32.64C38.4259 32.64 36.0566 34.7158 35.5996 37.44H1.91996C1.38977 37.44 0.959961 37.8698 0.959961 38.4C0.959961 38.9302 1.38977 39.36 1.91996 39.36H35.5996ZM37.44 38.4024C37.4413 40.5221 39.16 42.24 41.28 42.24C43.4007 42.24 45.12 40.5207 45.12 38.4C45.12 36.2792 43.4007 34.56 41.28 34.56C39.1592 34.56 37.44 36.2792 37.44 38.4V38.4024Z"
                fill="black"
            />
        </Icon>
    )
}

export default FiltersIcon
